<template>
  <div class="branding-preview-shell">
    <div class="branding-preview-toolbar">
      <div class="preview-app-label">HomePortal</div>
      <v-btn-toggle v-model="homePortalView" mandatory dense class="preview-view-toggle">
        <v-btn small>Landing / Login</v-btn>
        <v-btn small>Logged In</v-btn>
      </v-btn-toggle>
      <v-btn
        small
        outlined
        color="white"
        class="preview-export-btn"
        :loading="isExportingPdf"
        :disabled="isExportingPdf"
        @click="exportPreviewPdf"
      >
        Export PDF
      </v-btn>
    </div>

    <div ref="captureFrame" class="mock-browser full-window" :style="pageFrameStyle">
      <div class="mock-browser-toolbar">
        <span></span><span></span><span></span>
      </div>

      <div v-if="homePortalView === 0" class="hp-login-page" :style="pageBodyStyle">
        <div class="hp-navbar hp-navbar-login" :style="homePortalNavStyle">
          <div class="hp-mobile-toggle"><span></span></div>
          <div class="hp-brandmark">
            <img
              v-if="!usingFallbackLogo"
              :src="displayLogo"
              crossorigin="anonymous"
              class="preview-logo nav"
              alt="Preview Logo"
              @error="useFallbackLogo"
              @load="clearFallbackOverride"
            >
            <svg
              v-else
              class="preview-logo nav fallback-logo-inline"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 188.39 30"
              aria-label="HomePortal Logo"
              role="img"
            >
              <polygon fill="#231f20" points="17.59 0 0 15.48 5.42 15.48 5.42 30 13.36 30 13.36 18.41 21.65 18.41 21.65 30 29.59 30 29.59 15.48 35.02 15.48 17.59 0"/>
              <path fill="#231f20" d="M48.66,8,49.32,8l.7,0,.69,0,.67.08V16h8.17V8L60.19,8c.23,0,.47,0,.7,0l.7,0,.69.08v19.2a5.77,5.77,0,0,1-.65.08q-.35,0-.72,0l-.7,0a5.68,5.68,0,0,1-.66-.08V18.35H51.38v8.89c-.21,0-.43.06-.65.08s-.46,0-.71,0l-.71,0a5.5,5.5,0,0,1-.65-.08Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M72.31,27.56a6.63,6.63,0,0,1-2.8-.55,5.38,5.38,0,0,1-2-1.51,6.16,6.16,0,0,1-1.19-2.27,9.83,9.83,0,0,1-.39-2.83,9.93,9.93,0,0,1,.39-2.83,6.32,6.32,0,0,1,1.19-2.27,5.75,5.75,0,0,1,2-1.52,7.31,7.31,0,0,1,5.61,0,5.75,5.75,0,0,1,2,1.52,6.48,6.48,0,0,1,1.19,2.27,9.93,9.93,0,0,1,.39,2.83,9.83,9.83,0,0,1-.39,2.83,6.31,6.31,0,0,1-1.19,2.27,5.38,5.38,0,0,1-2,1.51A6.65,6.65,0,0,1,72.31,27.56Zm0-2.11A3,3,0,0,0,75,24.12a6.69,6.69,0,0,0,.88-3.72A6.58,6.58,0,0,0,75,16.71a3,3,0,0,0-2.73-1.33,3,3,0,0,0-2.71,1.33,6.76,6.76,0,0,0-.86,3.69,6.87,6.87,0,0,0,.86,3.72A3,3,0,0,0,72.31,25.45Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M82.17,13.54l.57-.08a5.52,5.52,0,0,1,.58,0,4.7,4.7,0,0,1,.54,0l.55.08c0,.27.11.62.16,1.06a10,10,0,0,1,.08,1.11,4.91,4.91,0,0,1,.6-.93,4.41,4.41,0,0,1,3.41-1.56,4,4,0,0,1,2.47.66,4.1,4.1,0,0,1,1.32,1.83,5.89,5.89,0,0,1,.65-.91A4.7,4.7,0,0,1,94,14a4.31,4.31,0,0,1,1.09-.56,4.05,4.05,0,0,1,1.39-.22,4.19,4.19,0,0,1,3.46,1.34,6.16,6.16,0,0,1,1.08,4v8.73a5.68,5.68,0,0,1-.66.08l-.67,0-.66,0a5.77,5.77,0,0,1-.65-.08v-8a5.45,5.45,0,0,0-.56-2.76A2,2,0,0,0,96,15.6a2.76,2.76,0,0,0-2.21,1,4.39,4.39,0,0,0-.84,2.91v7.74a5.5,5.5,0,0,1-.65.08l-.66,0-.65,0a5.5,5.5,0,0,1-.65-.08V19.1a5.31,5.31,0,0,0-.54-2.69A1.85,1.85,0,0,0,88,15.52a2.83,2.83,0,0,0-1.25.29,3,3,0,0,0-1,.88,4.58,4.58,0,0,0-.7,1.49,7.9,7.9,0,0,0-.25,2.06v7a5.77,5.77,0,0,1-.65.08l-.66,0-.66,0a5.61,5.61,0,0,1-.67-.08Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M107,21.05a4.44,4.44,0,0,0,1.16,3.28,4.63,4.63,0,0,0,3.27,1,9.71,9.71,0,0,0,3.6-.67,3.86,3.86,0,0,1,.35,1,6.41,6.41,0,0,1,.16,1.13,8.68,8.68,0,0,1-1.93.56,13,13,0,0,1-2.34.19A8.78,8.78,0,0,1,108,27a5.65,5.65,0,0,1-3.47-3.71,9.81,9.81,0,0,1-.4-2.85,10,10,0,0,1,.39-2.84,6.37,6.37,0,0,1,1.19-2.3,5.63,5.63,0,0,1,2-1.54,6.58,6.58,0,0,1,2.88-.58,6,6,0,0,1,2.48.48A5.06,5.06,0,0,1,114.88,15,5.73,5.73,0,0,1,116,17a8.12,8.12,0,0,1,.38,2.52c0,.25,0,.51,0,.79s0,.51,0,.71Zm6.78-2a5.2,5.2,0,0,0-.2-1.43,3.59,3.59,0,0,0-.59-1.19,2.92,2.92,0,0,0-1-.81,3,3,0,0,0-1.42-.31,3.15,3.15,0,0,0-2.5,1A4.85,4.85,0,0,0,107,19.07Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M120,8l1-.1,1.15-.1,1.2-.06,1.16,0a13.19,13.19,0,0,1,2.79.29,6.27,6.27,0,0,1,2.32,1,5.05,5.05,0,0,1,1.59,1.91,6.7,6.7,0,0,1,.59,3,6.86,6.86,0,0,1-.63,3.11,5.58,5.58,0,0,1-1.65,2,6.54,6.54,0,0,1-2.34,1.05,11.34,11.34,0,0,1-2.67.31l-.89,0c-.26,0-.54,0-.84-.06v6.94a11.88,11.88,0,0,1-1.37.08h-.68a4.89,4.89,0,0,1-.68-.07Zm2.73,9.91.74.08c.22,0,.53,0,.94,0a7.56,7.56,0,0,0,1.64-.18,3.78,3.78,0,0,0,1.45-.62,3.32,3.32,0,0,0,1-1.24,4.65,4.65,0,0,0,.39-2.05,4.55,4.55,0,0,0-.33-1.84,3,3,0,0,0-.93-1.2,3.51,3.51,0,0,0-1.41-.64,7.8,7.8,0,0,0-1.79-.19,17.22,17.22,0,0,0-1.73.08Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M140.49,27.56a6.65,6.65,0,0,1-2.81-.55,5.38,5.38,0,0,1-2-1.51,6.16,6.16,0,0,1-1.19-2.27,9.83,9.83,0,0,1-.39-2.83,9.93,9.93,0,0,1,.39-2.83,6.32,6.32,0,0,1,1.19-2.27,5.75,5.75,0,0,1,2-1.52,7.31,7.31,0,0,1,5.61,0,5.75,5.75,0,0,1,2,1.52,6.32,6.32,0,0,1,1.19,2.27,9.93,9.93,0,0,1,.39,2.83,9.83,9.83,0,0,1-.39,2.83,6.16,6.16,0,0,1-1.19,2.27,5.38,5.38,0,0,1-2,1.51A6.63,6.63,0,0,1,140.49,27.56Zm0-2.11a3,3,0,0,0,2.72-1.33,6.69,6.69,0,0,0,.88-3.72,6.58,6.58,0,0,0-.88-3.69,3.45,3.45,0,0,0-5.44,0,6.76,6.76,0,0,0-.86,3.69,6.87,6.87,0,0,0,.86,3.72A3,3,0,0,0,140.49,25.45Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M150.34,13.54l.56-.08a5.06,5.06,0,0,1,.56,0c.19,0,.39,0,.59,0l.53.08c0,.27.11.62.16,1.06a10,10,0,0,1,.08,1.11,5.42,5.42,0,0,1,1.48-1.58,3.91,3.91,0,0,1,2.37-.67l.44,0a1.92,1.92,0,0,1,.38,0,2.74,2.74,0,0,1,.08.5,5.45,5.45,0,0,1,0,1.23c0,.23-.06.46-.09.67a1.65,1.65,0,0,0-.44-.05h-.36a4.47,4.47,0,0,0-1.38.2,2.82,2.82,0,0,0-1.17.7,3.43,3.43,0,0,0-.83,1.39,6.91,6.91,0,0,0-.31,2.27v6.81a5.77,5.77,0,0,1-.65.08l-.66,0-.65,0a6.69,6.69,0,0,1-.68-.08Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M160.78,15.65h-2.09l-.1-.37,4.59-5.13h.21v3.39h3.48a4.58,4.58,0,0,1,.1,1c0,.19,0,.38,0,.56s0,.35-.08.53h-3.48V21.9a13.78,13.78,0,0,0,.1,1.79,2.66,2.66,0,0,0,.32,1,1.07,1.07,0,0,0,.61.48,3.4,3.4,0,0,0,1,.12,4.64,4.64,0,0,0,.85-.07,5.66,5.66,0,0,0,.72-.15,4.15,4.15,0,0,1,.23,1.1c0,.37,0,.7,0,1a9.67,9.67,0,0,1-1.12.2,12.38,12.38,0,0,1-1.26.06,4.45,4.45,0,0,1-3-.93,3.91,3.91,0,0,1-1.08-3.1Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M177.07,18.22a2.58,2.58,0,0,0-.81-2.19,3.73,3.73,0,0,0-2.32-.62,9.67,9.67,0,0,0-1.75.15,14.18,14.18,0,0,0-1.59.39,4.28,4.28,0,0,1-.5-2.11,12,12,0,0,1,2-.46,15.57,15.57,0,0,1,2.11-.16,6,6,0,0,1,4.06,1.22,4.92,4.92,0,0,1,1.39,3.88v8.57c-.63.15-1.38.29-2.27.44a15.4,15.4,0,0,1-2.73.23,10.64,10.64,0,0,1-2.36-.24,5,5,0,0,1-1.79-.77,3.62,3.62,0,0,1-1.14-1.37,4.63,4.63,0,0,1-.4-2,4.17,4.17,0,0,1,.47-2,4.32,4.32,0,0,1,1.27-1.45,5.76,5.76,0,0,1,1.84-.85,8.32,8.32,0,0,1,2.19-.28c.57,0,1,0,1.4,0l.93.09Zm0,2.59c-.27,0-.61-.08-1-.11s-.76-.05-1-.05a4.32,4.32,0,0,0-2.52.61,2.13,2.13,0,0,0-.87,1.87,2.33,2.33,0,0,0,.29,1.25,2,2,0,0,0,.74.7,2.39,2.39,0,0,0,1,.29,9.15,9.15,0,0,0,1,.05c.4,0,.83,0,1.26-.06a8.33,8.33,0,0,0,1.17-.2Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M183.58,7.67a6,6,0,0,1,.66-.08l.65,0,.65,0a6,6,0,0,1,.66.08V23.1a4.13,4.13,0,0,0,.13,1.18,1.6,1.6,0,0,0,.36.65,1,1,0,0,0,.54.29,2.7,2.7,0,0,0,.65.07l.55,0a2.37,2.37,0,0,0,.52-.08,8.19,8.19,0,0,1,.24,2,3.57,3.57,0,0,1-.91.18c-.36,0-.68,0-1,0a5.17,5.17,0,0,1-1.44-.19,3,3,0,0,1-1.17-.61,2.86,2.86,0,0,1-.8-1.15,4.68,4.68,0,0,1-.3-1.79Z" transform="translate(-0.8 -2.11)"/>
            </svg>
          </div>
          <div class="hp-nav-actions">
            <span class="hp-nav-link">Book classes</span>
            <span class="hp-nav-link active-nav">login</span>
            <div class="hp-language-select" :style="homePortalLanguageStyle">
              <span>en</span>
              <span class="hp-language-caret"></span>
            </div>
          </div>
        </div>

        <div class="hp-login-content">
          <div class="hp-page-container">
            <div class="hp-oj-banner preview-card soft-card html-reference-card hp-bootstrap-card">
            <div class="hp-oj-banner-copy">
              <h4>Online booking</h4>
              <p>View availability and book online.</p>
            </div>
            <button class="cta-secondary compact btn-homeportal" :style="secondaryButtonStyle">Book class</button>
            </div>

            <div class="hp-login-grid html-reference-grid">
              <section class="hp-login-column">
                <h4 class="section-title hp-card-title">Log in to HomePortal</h4>
                <div class="preview-card hp-login-card html-reference-card hp-bootstrap-card">
                  <div class="field-label">Enter email</div>
                  <div class="input-mock with-icon html-input hp-input-group">
                    <span class="input-icon">
                      <svg class="input-icon-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
                        <circle cx="12" cy="8" r="4" fill="#585858"/>
                        <path d="M4 20c1.7-4 5-6 8-6s6.3 2 8 6" fill="none" stroke="#585858" stroke-width="2" stroke-linecap="round"/>
                      </svg>
                    </span>
                    <span>Email address</span>
                  </div>
                  <div class="field-label">Enter password</div>
                  <div class="input-mock with-icon html-input hp-input-group">
                    <span class="input-icon">
                      <svg class="input-icon-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
                        <rect x="5" y="11" width="14" height="10" rx="2" fill="#585858"/>
                        <path d="M8 11V8a4 4 0 0 1 8 0v3" fill="none" stroke="#585858" stroke-width="2" stroke-linecap="round"/>
                      </svg>
                    </span>
                    <span>Password</span>
                  </div>
                  <button class="cta-secondary full-width btn-homeportal" :style="secondaryButtonStyle">Log in</button>
                  <div class="link-row">
                    <span class="inline-link" :style="{ color: brandData.colors.secondary || '#f6ad55' }">Forgot password?</span>
                  </div>
                </div>
              </section>

              <section class="hp-login-column">
                <h4 class="section-title hp-card-title">Activate HomePortal</h4>
                <div class="preview-card hp-activate-card html-reference-card hp-bootstrap-card">
                  <p class="activation-copy">Activate HomePortal account to enjoy the following benefits:</p>
                  <ul class="benefits-list">
                    <li>Top up and move classes 24/7.</li>
                    <li>View your account details.</li>
                    <li>View progress updates on lessons and courses.</li>
                  </ul>
                  <button class="cta-secondary full-width btn-homeportal" :style="secondaryButtonStyle">Activate</button>
                </div>
              </section>
            </div>
          </div>
        </div>

        <div id="cookieConsent" class="cookie-container preview-cookie-container">
          <h4>This website is using cookies.</h4>
          <p>This site uses cookies however no marketing or advertising cookies are used. Please confirm that you are happy to continue with cookies.</p>
          <div class="cookie-buttons">
            <a id="privacy-policy-internal" class="hyperlink text-white mr-4" tabindex="1">Learn More</a>
            <button id="cookie-consent-agree" class="btn btn-secondary px-4 py-0 btn-homeportal compact" tabindex="1" :style="secondaryButtonStyle">
              OK
            </button>
          </div>
        </div>

      </div>

      <div v-else class="hp-dashboard-page" :style="pageBodyStyle">
        <div class="hp-navbar hp-navbar-login logged-in" :style="homePortalNavStyle">
          <div class="hp-mobile-toggle"><span></span></div>
          <div class="hp-brandmark">
            <img
              v-if="!usingFallbackLogo"
              :src="displayLogo"
              crossorigin="anonymous"
              class="preview-logo nav"
              alt="Preview Logo"
              @error="useFallbackLogo"
              @load="clearFallbackOverride"
            >
            <svg
              v-else
              class="preview-logo nav fallback-logo-inline"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 188.39 30"
              aria-label="HomePortal Logo"
              role="img"
            >
              <polygon fill="#231f20" points="17.59 0 0 15.48 5.42 15.48 5.42 30 13.36 30 13.36 18.41 21.65 18.41 21.65 30 29.59 30 29.59 15.48 35.02 15.48 17.59 0"/>
              <path fill="#231f20" d="M48.66,8,49.32,8l.7,0,.69,0,.67.08V16h8.17V8L60.19,8c.23,0,.47,0,.7,0l.7,0,.69.08v19.2a5.77,5.77,0,0,1-.65.08q-.35,0-.72,0l-.7,0a5.68,5.68,0,0,1-.66-.08V18.35H51.38v8.89c-.21,0-.43.06-.65.08s-.46,0-.71,0l-.71,0a5.5,5.5,0,0,1-.65-.08Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M72.31,27.56a6.63,6.63,0,0,1-2.8-.55,5.38,5.38,0,0,1-2-1.51,6.16,6.16,0,0,1-1.19-2.27,9.83,9.83,0,0,1-.39-2.83,9.93,9.93,0,0,1,.39-2.83,6.32,6.32,0,0,1,1.19-2.27,5.75,5.75,0,0,1,2-1.52,7.31,7.31,0,0,1,5.61,0,5.75,5.75,0,0,1,2,1.52,6.48,6.48,0,0,1,1.19,2.27,9.93,9.93,0,0,1,.39,2.83,9.83,9.83,0,0,1-.39,2.83,6.31,6.31,0,0,1-1.19,2.27,5.38,5.38,0,0,1-2,1.51A6.65,6.65,0,0,1,72.31,27.56Zm0-2.11A3,3,0,0,0,75,24.12a6.69,6.69,0,0,0,.88-3.72A6.58,6.58,0,0,0,75,16.71a3,3,0,0,0-2.73-1.33,3,3,0,0,0-2.71,1.33,6.76,6.76,0,0,0-.86,3.69,6.87,6.87,0,0,0,.86,3.72A3,3,0,0,0,72.31,25.45Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M82.17,13.54l.57-.08a5.52,5.52,0,0,1,.58,0,4.7,4.7,0,0,1,.54,0l.55.08c0,.27.11.62.16,1.06a10,10,0,0,1,.08,1.11,4.91,4.91,0,0,1,.6-.93,4.41,4.41,0,0,1,3.41-1.56,4,4,0,0,1,2.47.66,4.1,4.1,0,0,1,1.32,1.83,5.89,5.89,0,0,1,.65-.91A4.7,4.7,0,0,1,94,14a4.31,4.31,0,0,1,1.09-.56,4.05,4.05,0,0,1,1.39-.22,4.19,4.19,0,0,1,3.46,1.34,6.16,6.16,0,0,1,1.08,4v8.73a5.68,5.68,0,0,1-.66.08l-.67,0-.66,0a5.77,5.77,0,0,1-.65-.08v-8a5.45,5.45,0,0,0-.56-2.76A2,2,0,0,0,96,15.6a2.76,2.76,0,0,0-2.21,1,4.39,4.39,0,0,0-.84,2.91v7.74a5.5,5.5,0,0,1-.65.08l-.66,0-.65,0a5.5,5.5,0,0,1-.65-.08V19.1a5.31,5.31,0,0,0-.54-2.69A1.85,1.85,0,0,0,88,15.52a2.83,2.83,0,0,0-1.25.29,3,3,0,0,0-1,.88,4.58,4.58,0,0,0-.7,1.49,7.9,7.9,0,0,0-.25,2.06v7a5.77,5.77,0,0,1-.65.08l-.66,0-.66,0a5.61,5.61,0,0,1-.67-.08Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M107,21.05a4.44,4.44,0,0,0,1.16,3.28,4.63,4.63,0,0,0,3.27,1,9.71,9.71,0,0,0,3.6-.67,3.86,3.86,0,0,1,.35,1,6.41,6.41,0,0,1,.16,1.13,8.68,8.68,0,0,1-1.93.56,13,13,0,0,1-2.34.19A8.78,8.78,0,0,1,108,27a5.65,5.65,0,0,1-3.47-3.71,9.81,9.81,0,0,1-.4-2.85,10,10,0,0,1,.39-2.84,6.37,6.37,0,0,1,1.19-2.3,5.63,5.63,0,0,1,2-1.54,6.58,6.58,0,0,1,2.88-.58,6,6,0,0,1,2.48.48A5.06,5.06,0,0,1,114.88,15,5.73,5.73,0,0,1,116,17a8.12,8.12,0,0,1,.38,2.52c0,.25,0,.51,0,.79s0,.51,0,.71Zm6.78-2a5.2,5.2,0,0,0-.2-1.43,3.59,3.59,0,0,0-.59-1.19,2.92,2.92,0,0,0-1-.81,3,3,0,0,0-1.42-.31,3.15,3.15,0,0,0-2.5,1A4.85,4.85,0,0,0,107,19.07Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M120,8l1-.1,1.15-.1,1.2-.06,1.16,0a13.19,13.19,0,0,1,2.79.29,6.27,6.27,0,0,1,2.32,1,5.05,5.05,0,0,1,1.59,1.91,6.7,6.7,0,0,1,.59,3,6.86,6.86,0,0,1-.63,3.11,5.58,5.58,0,0,1-1.65,2,6.54,6.54,0,0,1-2.34,1.05,11.34,11.34,0,0,1-2.67.31l-.89,0c-.26,0-.54,0-.84-.06v6.94a11.88,11.88,0,0,1-1.37.08h-.68a4.89,4.89,0,0,1-.68-.07Zm2.73,9.91.74.08c.22,0,.53,0,.94,0a7.56,7.56,0,0,0,1.64-.18,3.78,3.78,0,0,0,1.45-.62,3.32,3.32,0,0,0,1-1.24,4.65,4.65,0,0,0,.39-2.05,4.55,4.55,0,0,0-.33-1.84,3,3,0,0,0-.93-1.2,3.51,3.51,0,0,0-1.41-.64,7.8,7.8,0,0,0-1.79-.19,17.22,17.22,0,0,0-1.73.08Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M140.49,27.56a6.65,6.65,0,0,1-2.81-.55,5.38,5.38,0,0,1-2-1.51,6.16,6.16,0,0,1-1.19-2.27,9.83,9.83,0,0,1-.39-2.83,9.93,9.93,0,0,1,.39-2.83,6.32,6.32,0,0,1,1.19-2.27,5.75,5.75,0,0,1,2-1.52,7.31,7.31,0,0,1,5.61,0,5.75,5.75,0,0,1,2,1.52,6.32,6.32,0,0,1,1.19,2.27,9.93,9.93,0,0,1,.39,2.83,9.83,9.83,0,0,1-.39,2.83,6.16,6.16,0,0,1-1.19,2.27,5.38,5.38,0,0,1-2,1.51A6.63,6.63,0,0,1,140.49,27.56Zm0-2.11a3,3,0,0,0,2.72-1.33,6.69,6.69,0,0,0,.88-3.72,6.58,6.58,0,0,0-.88-3.69,3.45,3.45,0,0,0-5.44,0,6.76,6.76,0,0,0-.86,3.69,6.87,6.87,0,0,0,.86,3.72A3,3,0,0,0,140.49,25.45Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M150.34,13.54l.56-.08a5.06,5.06,0,0,1,.56,0c.19,0,.39,0,.59,0l.53.08c0,.27.11.62.16,1.06a10,10,0,0,1,.08,1.11,5.42,5.42,0,0,1,1.48-1.58,3.91,3.91,0,0,1,2.37-.67l.44,0a1.92,1.92,0,0,1,.38,0,2.74,2.74,0,0,1,.08.5,5.45,5.45,0,0,1,0,1.23c0,.23-.06.46-.09.67a1.65,1.65,0,0,0-.44-.05h-.36a4.47,4.47,0,0,0-1.38.2,2.82,2.82,0,0,0-1.17.7,3.43,3.43,0,0,0-.83,1.39,6.91,6.91,0,0,0-.31,2.27v6.81a5.77,5.77,0,0,1-.65.08l-.66,0-.65,0a6.69,6.69,0,0,1-.68-.08Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M160.78,15.65h-2.09l-.1-.37,4.59-5.13h.21v3.39h3.48a4.58,4.58,0,0,1,.1,1c0,.19,0,.38,0,.56s0,.35-.08.53h-3.48V21.9a13.78,13.78,0,0,0,.1,1.79,2.66,2.66,0,0,0,.32,1,1.07,1.07,0,0,0,.61.48,3.4,3.4,0,0,0,1,.12,4.64,4.64,0,0,0,.85-.07,5.66,5.66,0,0,0,.72-.15,4.15,4.15,0,0,1,.23,1.1c0,.37,0,.7,0,1a9.67,9.67,0,0,1-1.12.2,12.38,12.38,0,0,1-1.26.06,4.45,4.45,0,0,1-3-.93,3.91,3.91,0,0,1-1.08-3.1Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M177.07,18.22a2.58,2.58,0,0,0-.81-2.19,3.73,3.73,0,0,0-2.32-.62,9.67,9.67,0,0,0-1.75.15,14.18,14.18,0,0,0-1.59.39,4.28,4.28,0,0,1-.5-2.11,12,12,0,0,1,2-.46,15.57,15.57,0,0,1,2.11-.16,6,6,0,0,1,4.06,1.22,4.92,4.92,0,0,1,1.39,3.88v8.57c-.63.15-1.38.29-2.27.44a15.4,15.4,0,0,1-2.73.23,10.64,10.64,0,0,1-2.36-.24,5,5,0,0,1-1.79-.77,3.62,3.62,0,0,1-1.14-1.37,4.63,4.63,0,0,1-.4-2,4.17,4.17,0,0,1,.47-2,4.32,4.32,0,0,1,1.27-1.45,5.76,5.76,0,0,1,1.84-.85,8.32,8.32,0,0,1,2.19-.28c.57,0,1,0,1.4,0l.93.09Zm0,2.59c-.27,0-.61-.08-1-.11s-.76-.05-1-.05a4.32,4.32,0,0,0-2.52.61,2.13,2.13,0,0,0-.87,1.87,2.33,2.33,0,0,0,.29,1.25,2,2,0,0,0,.74.7,2.39,2.39,0,0,0,1,.29,9.15,9.15,0,0,0,1,.05c.4,0,.83,0,1.26-.06a8.33,8.33,0,0,0,1.17-.2Z" transform="translate(-0.8 -2.11)"/>
              <path fill="#231f20" d="M183.58,7.67a6,6,0,0,1,.66-.08l.65,0,.65,0a6,6,0,0,1,.66.08V23.1a4.13,4.13,0,0,0,.13,1.18,1.6,1.6,0,0,0,.36.65,1,1,0,0,0,.54.29,2.7,2.7,0,0,0,.65.07l.55,0a2.37,2.37,0,0,0,.52-.08,8.19,8.19,0,0,1,.24,2,3.57,3.57,0,0,1-.91.18c-.36,0-.68,0-1,0a5.17,5.17,0,0,1-1.44-.19,3,3,0,0,1-1.17-.61,2.86,2.86,0,0,1-.8-1.15,4.68,4.68,0,0,1-.3-1.79Z" transform="translate(-0.8 -2.11)"/>
            </svg>
          </div>
          <div class="hp-nav-actions">
            <span class="hp-nav-link active-nav" :style="{ color: brandData.colors.secondary || '#f6ad55', borderBottomColor: brandData.colors.secondary || '#f6ad55' }">Overview</span>
            <span class="hp-nav-link">Book classes</span>
            <span class="hp-nav-link">Account</span>
            <span class="hp-nav-link">Logout</span>
            <div class="hp-language-select" :style="homePortalLanguageStyle">
              <span>en</span>
              <span class="hp-language-caret"></span>
            </div>
          </div>
        </div>

        <div class="hp-dashboard-content hp-overview-content">
          <div class="hp-page-container">
            <div class="hp-overview-grid">
              <div class="hp-overview-left">
                <div class="hp-overview-panel preview-card hp-bootstrap-card hp-overview-shell">
                  <div class="hp-members-container">
                    <div class="hp-member-card preview-card hp-bootstrap-card">
                      <div class="hp-member-header">
                        <span class="hp-member-icon">
                          <svg class="input-icon-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
                            <circle cx="12" cy="8" r="4" fill="#585858"/>
                            <path d="M4 20c1.7-4 5-6 8-6s6.3 2 8 6" fill="none" stroke="#585858" stroke-width="2" stroke-linecap="round"/>
                          </svg>
                        </span>
                        <h1 class="hp-member-name">
                          Addison Schmidt
                          <small>10000072</small>
                        </h1>
                      </div>
                      <div class="hp-member-body arrow-box">
                        <div class="hp-member-body-inner">
                          <div class="progress-circle">
                            <div class="progress">
                              <span class="progress-left"><span class="progress-bar"></span></span>
                              <span class="progress-right"><span class="progress-bar"></span></span>
                              <div class="progress-value"><div class="question-mark">?</div></div>
                            </div>
                          </div>
                          <div class="hp-member-copy">
                            <p class="hp-member-status">Not attending any classes</p>
                            <span class="hp-member-subcopy">Why not find one?</span>
                            <div class="onlinejoining-actions">
                              <button class="cta-secondary compact hp-action-btn" :style="secondaryButtonStyle">Book classes</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="hp-member-card preview-card hp-bootstrap-card">
                      <div class="hp-member-header">
                        <span class="hp-member-icon">
                          <svg class="input-icon-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
                            <circle cx="12" cy="8" r="4" fill="#585858"/>
                            <path d="M4 20c1.7-4 5-6 8-6s6.3 2 8 6" fill="none" stroke="#585858" stroke-width="2" stroke-linecap="round"/>
                          </svg>
                        </span>
                        <h1 class="hp-member-name">
                          Mariam Schmidt
                          <small>10000297</small>
                        </h1>
                      </div>
                      <div class="hp-member-body arrow-box">
                        <div class="hp-member-body-inner">
                          <div class="progress-circle">
                            <div class="progress">
                              <span class="progress-left"><span class="progress-bar"></span></span>
                              <span class="progress-right"><span class="progress-bar"></span></span>
                              <div class="progress-value"><div class="question-mark">?</div></div>
                            </div>
                          </div>
                          <div class="hp-member-copy">
                            <p class="hp-member-status">Not attending any classes</p>
                            <span class="hp-member-subcopy">Why not find one?</span>
                            <div class="onlinejoining-actions">
                              <button class="cta-secondary compact hp-action-btn" :style="secondaryButtonStyle">Book classes</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div id="add-member" class="hp-add-member preview-card hp-bootstrap-card">
                      <button class="hp-add-member-trigger">
                        <span class="hp-plus"></span>
                        <span>Add member</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="hp-overview-right">
                <div class="hp-sticky-panel">
                  <div class="hp-overview-panel preview-card hp-bootstrap-card hp-summary-shell">
                    <div class="hp-summary-card preview-card hp-bootstrap-card">
                      <div class="hp-summary-header active" :style="{ color: brandData.colors.secondary || '#f6ad55' }">Skills</div>
                      <div class="hp-summary-body hp-empty-state">No skill records to display</div>
                    </div>

                    <div class="hp-summary-card preview-card hp-bootstrap-card">
                      <div class="hp-summary-header active" :style="{ color: brandData.colors.secondary || '#f6ad55' }">Waiting lists</div>
                      <div class="hp-summary-body hp-empty-state">No waiting lists</div>
                    </div>

                    <div class="hp-summary-card preview-card hp-bootstrap-card">
                      <div class="hp-summary-header active" :style="{ color: brandData.colors.secondary || '#f6ad55' }">Class history</div>
                      <div class="hp-summary-body">
                        <div class="hp-history-head">
                          <div class="hp-history-course">Course</div>
                          <div class="hp-history-name">Class name</div>
                        </div>
                        <div class="hp-history-item">
                          <div class="hp-history-course">Swim School (Continuous)</div>
                          <div class="hp-history-copy">
                            <span class="hp-history-title" :style="{ color: brandData.colors.secondary || '#f6ad55' }">Stage 6</span>
                            <div class="hp-history-meta">
                              <span>Started: Sunday, February 1st 2026</span>
                              <span>No end date</span>
                            </div>
                          </div>
                        </div>
                        <div class="hp-history-item">
                          <div class="hp-history-course">Swim School (Continuous)</div>
                          <div class="hp-history-copy">
                            <span class="hp-history-title" :style="{ color: brandData.colors.secondary || '#f6ad55' }">Stage 5</span>
                            <div class="hp-history-meta">
                              <span>Started: Saturday, December 27th 2025</span>
                              <span>Completed: Saturday, January 31st 2026</span>
                            </div>
                          </div>
                        </div>
                        <div class="hp-history-actions">
                          <button class="cta-primary compact btn-homeportal" :style="primaryButtonStyle">View all history</button>
                        </div>
                      </div>
                    </div>

                    <div class="hp-summary-card preview-card hp-bootstrap-card">
                      <div class="hp-summary-header active" :style="{ color: brandData.colors.secondary || '#f6ad55' }">Badges</div>
                      <div class="hp-summary-body">
                        <div class="hp-badge-row">
                          <div class="hp-badge-illustration">
                            <svg class="hp-badge-empty-image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78 110.1" aria-label="No badge yet" role="img" preserveAspectRatio="xMidYMid meet">
                              <path fill="#DFDFDF" d="M39,19c7.8,0.1,15.5,0.8,23.2,2.1L75.1,8.2L52,13.6L39,0L26,13.6L2.9,8.2l13,12.9C23.5,19.8,31.2,19.1,39,19z"/>
                              <path fill="#DFDFDF" d="M39,27.4c11.9,0.2,23.6,2,35,5.3v41.8c0,18.2-28.8,29.2-35,31.3c-6.2-2.2-35-13.2-35-31.3V32.7C15.4,29.4,27.1,27.6,39,27.4 M39,23.4c-13.2,0.2-26.4,2.4-39,6.4v44.7c0,23.5,39,35.6,39,35.6s39-12,39-35.6V29.8C65.4,25.8,52.2,23.6,39,23.4L39,23.4z"/>
                            </svg>
                          </div>
                          <div class="hp-badge-copy">
                            <span class="hp-badge-title">You will find badges here</span>
                            <span class="hp-badge-subtitle">and find out when they were achieved ...</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

const resolvedPdfFonts = pdfFonts?.pdfMake?.vfs
  || pdfFonts?.default?.pdfMake?.vfs
  || pdfFonts?.vfs
  || pdfFonts?.default
  || pdfFonts

if (typeof pdfMake.addVirtualFileSystem === 'function') {
  pdfMake.addVirtualFileSystem(resolvedPdfFonts)
} else {
  pdfMake.vfs = resolvedPdfFonts
}

export default {
  name: 'TenantHomeportal2BrandingPreview',
  props: {
    brandData: {
      type: Object,
      required: true
    },
    logoPreviewUrl: {
      type: String,
      default: null
    },
    tenantName: {
      type: String,
      default: 'Tenant'
    }
  },
  data: () => ({
    homePortalView: 0,
    isExportingPdf: false,
    forceFallbackLogo: false,
  }),
  methods: {
    useFallbackLogo() {
      this.forceFallbackLogo = true;
    },
    clearFallbackOverride(event) {
      if (event?.target?.currentSrc === this.fallbackHomeportalLogo) {
        return;
      }

      this.forceFallbackLogo = false;
    },
    async exportPreviewPdf() {
      if (this.isExportingPdf) {
        return;
      }

      const originalState = {
        homePortalView: this.homePortalView
      };

      const exportStates = [
        { homePortalView: 0, label: 'homeportal-login' },
        { homePortalView: 1, label: 'homeportal-logged-in' }
      ];

      try {
        this.isExportingPdf = true;
        const pageWidth = 841.89;
        const pageHeight = 595.28;
        const pageMargin = 18;
        const usableWidth = pageWidth - (pageMargin * 2);
        const usableHeight = pageHeight - (pageMargin * 2);
        const pdfContent = [];

        for (let index = 0; index < exportStates.length; index += 1) {
          const state = exportStates[index];

          this.homePortalView = state.homePortalView;

          await this.$nextTick();
          await this.waitForRenderStability();

          const frame = this.$refs.captureFrame;
          const restoreImages = await this.inlineFrameImages(frame);
          let canvas;

          try {
            canvas = await html2canvas(frame, {
              backgroundColor: '#ffffff',
              scale: 2,
              useCORS: true,
              logging: false,
              windowWidth: frame.scrollWidth,
              windowHeight: frame.scrollHeight
            });
          } finally {
            restoreImages();
          }

          const imageWidth = canvas.width;
          const imageHeight = canvas.height;
          const widthRatio = usableWidth / imageWidth;
          const heightRatio = usableHeight / imageHeight;
          const ratio = Math.min(widthRatio, heightRatio);
          const renderWidth = imageWidth * ratio;
          const renderHeight = imageHeight * ratio;
          const topMargin = Math.max((usableHeight - renderHeight) / 2, 0);

          pdfContent.push({
            image: canvas.toDataURL('image/png'),
            width: renderWidth,
            height: renderHeight,
            alignment: 'center',
            margin: [0, topMargin, 0, 0],
            pageBreak: index < exportStates.length - 1 ? 'after' : undefined
          });
        }

        const safeTenantName = (this.tenantName || 'tenant')
          .toString()
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '') || 'tenant';

        pdfMake.createPdf({
          pageSize: 'A4',
          pageOrientation: 'landscape',
          pageMargins: [pageMargin, pageMargin, pageMargin, pageMargin],
          content: pdfContent
        }).download(`${safeTenantName}-branding-preview.pdf`);
      } finally {
        this.homePortalView = originalState.homePortalView;
        this.isExportingPdf = false;
      }
    },
    async waitForRenderStability() {
      await new Promise(resolve => requestAnimationFrame(() => resolve()));
      await new Promise(resolve => setTimeout(resolve, 120));
      await this.waitForImages();
      if (document.fonts && document.fonts.ready) {
        try {
          await document.fonts.ready;
        } catch (e) {
          // Ignore font loading failures during export and continue with current render.
        }
      }
    },
    async waitForImages() {
      const frame = this.$refs.captureFrame;
      if (!frame) {
        return;
      }

      const images = Array.from(frame.querySelectorAll('img'));
      await Promise.all(images.map(image => {
        if (image.complete) {
          return Promise.resolve();
        }

        return new Promise(resolve => {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });
      }));
    },
    async inlineFrameImages(frame) {
      if (!frame) {
        return () => {};
      }

      const images = Array.from(frame.querySelectorAll('img'));
      const originalSources = images.map(image => image.getAttribute('src'));

      await Promise.all(images.map(async image => {
        const source = image.getAttribute('src');

        if (!source || source.startsWith('data:') || source.startsWith('blob:')) {
          return;
        }

        try {
          const response = await fetch(source, { mode: 'cors' });

          if (!response.ok) {
            return;
          }

          const blob = await response.blob();
          const dataUrl = await this.blobToDataUrl(blob);
          const imageLoadPromise = this.waitForImageSourceSwap(image, dataUrl);
          image.setAttribute('src', dataUrl);
          await imageLoadPromise;
        } catch (e) {
          // Keep the original source if the browser cannot inline it.
        }
      }));

      return () => {
        images.forEach((image, index) => {
          const originalSource = originalSources[index];

          if (originalSource) {
            image.setAttribute('src', originalSource);
          }
        });
      };
    },
    blobToDataUrl(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },
    waitForImageSourceSwap(image, nextSource) {
      return new Promise(resolve => {
        const settle = () => resolve();
        const currentSource = image.currentSrc || image.getAttribute('src') || '';

        if (currentSource === nextSource && image.complete) {
          settle();
          return;
        }

        image.addEventListener('load', settle, { once: true });
        image.addEventListener('error', settle, { once: true });
      });
    }
  },
  computed: {
    displayLogo() {
      if (this.forceFallbackLogo) {
        return this.fallbackHomeportalLogo;
      }

      const previewLogo = typeof this.logoPreviewUrl === 'string' ? this.logoPreviewUrl.trim() : '';
      const persistedLogo = typeof this.brandData.logoUrl === 'string' ? this.brandData.logoUrl.trim() : '';

      return previewLogo || persistedLogo || this.fallbackHomeportalLogo;
    },
    usingFallbackLogo() {
      if (this.forceFallbackLogo) {
        return true;
      }

      const previewLogo = typeof this.logoPreviewUrl === 'string' ? this.logoPreviewUrl.trim() : '';
      const persistedLogo = typeof this.brandData.logoUrl === 'string' ? this.brandData.logoUrl.trim() : '';

      return !previewLogo && !persistedLogo;
    },
    fallbackHomeportalLogo() {
      return null;
    },
    homePortalNavStyle() {
      return {
        backgroundColor: this.brandData.colors.primary || '#55a440',
        borderColor: this.brandData.colors.primary || '#55a440'
      };
    },
    homePortalLanguageStyle() {
      return {
        backgroundColor: this.brandData.colors.secondary || '#f6ad55',
        color: '#ffffff',
        borderColor: this.brandData.colors.secondary || '#f6ad55'
      };
    },
    pageFrameStyle() {
      return {
        backgroundColor: this.brandData.colors.background || '#e8e8e8'
      };
    },
    pageBodyStyle() {
      return {
        background: `linear-gradient(180deg, ${this.brandData.colors.background || '#eef2f6'} 0%, #ffffff 100%)`
      };
    },
    primaryButtonStyle() {
      return {
        backgroundColor: this.brandData.colors.primary || '#4299e1',
        color: '#ffffff'
      };
    },
    secondaryButtonStyle() {
      return {
        backgroundColor: this.brandData.colors.secondary || '#f6ad55',
        color: '#ffffff'
      };
    }
  },
  watch: {
    logoPreviewUrl() {
      this.forceFallbackLogo = false;
    }
  }
}
</script>

<style scoped>
.branding-preview-shell {
  color: #f8fafc;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.branding-preview-toolbar {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  min-width: 0;
}

.preview-app-label {
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #ffffff;
  flex: 0 0 auto;
  min-width: 0;
}

.preview-view-toggle {
  background: rgba(15, 23, 42, 0.42);
  min-width: 0;
  max-width: 100%;
}

.preview-export-btn {
  flex: 0 0 auto;
}

.mock-browser.full-window {
  border-radius: 0;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.35);
  min-height: calc(100vh - 210px);
}

.mock-browser-toolbar {
  display: flex;
  gap: 8px;
  padding: 12px 14px;
  background: rgba(15, 23, 42, 0.9);
}

.mock-browser-toolbar span {
  width: 10px;
  height: 10px;
  border-radius: 0;
  background: rgba(255, 255, 255, 0.35);
}

.hp-login-page,
.hp-dashboard-page {
  min-height: calc(100vh - 258px);
  display: flex;
  flex-direction: column;
  color: #0f172a;
}

.hp-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 20px 26px;
  background: rgba(255, 255, 255, 0.92);
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}

.hp-navbar-login {
  min-height: 93px;
  padding: 10px 26px;
  background: #ffffff !important;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08) !important;
}

.hp-mobile-toggle {
  width: 38px;
  height: 38px;
  border-radius: 0;
  border: 1px solid rgba(15, 23, 42, 0.18);
  background: transparent;
  display: none;
  align-items: center;
  justify-content: center;
}

.hp-mobile-toggle span,
.hp-mobile-toggle span::before,
.hp-mobile-toggle span::after {
  display: block;
  width: 16px;
  height: 2px;
  border-radius: 999px;
  background: #0f172a;
  content: '';
}

.hp-mobile-toggle span {
  position: relative;
}

.hp-mobile-toggle span::before {
  position: absolute;
  top: -5px;
  left: 0;
}

.hp-mobile-toggle span::after {
  position: absolute;
  top: 5px;
  left: 0;
}

.hp-navbar-login .hp-mobile-toggle span,
.hp-navbar-login .hp-mobile-toggle span::before,
.hp-navbar-login .hp-mobile-toggle span::after {
  background: #0f172a;
}

.hp-navbar.logged-in {
  position: sticky;
  top: 0;
}

.hp-brandmark {
  display: flex;
  align-items: center;
  min-height: 72px;
}

.hp-nav-actions {
  display: flex;
  align-items: center;
  gap: 14px;
  font-weight: 700;
  min-height: 72px;
  align-self: center;
  flex-wrap: wrap;
  min-width: 0;
}

.hp-nav-link {
  color: #0f172a;
  text-transform: uppercase;
  font-size: 1.03rem;
  padding: 5px;
  border-bottom: 4px solid transparent;
  line-height: 1.1;
  overflow-wrap: anywhere;
}

.active-nav {
  color: #f6ad55;
  border-bottom: 4px solid #f6ad55;
}

.hp-language-select {
  min-width: 86px;
  height: 38px;
  border: 1px solid transparent;
  border-radius: 0;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  color: #ffffff;
  text-transform: lowercase;
  font-size: 1.02rem;
  background: #f6ad55;
  align-self: center;
  line-height: 1;
}

.hp-language-caret {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #ffffff;
}

.hp-login-content,
.hp-dashboard-content {
  padding: 24px 26px 30px;
}

.hp-overview-content {
  padding-top: 28px;
}

.hp-page-container {
  width: 100%;
  max-width: 1140px;
  margin: 0 auto;
  min-width: 0;
}

.hp-oj-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-bottom: 22px;
}

.hp-login-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.hp-overview-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 24px;
  align-items: start;
  min-width: 0;
}

.hp-overview-shell,
.hp-summary-shell {
  padding: 0;
  background: transparent;
  border: 0;
}

.hp-sticky-panel {
  position: sticky;
  top: 126px;
}

.hp-members-container,
.hp-summary-shell {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-title {
  margin: 0 0 12px;
  font-size: 1.22rem;
  line-height: 1.2;
}

.preview-card {
  background: rgba(255, 255, 255, 0.97);
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 0;
  padding: 20px;
  box-shadow: 0 12px 35px rgba(15, 23, 42, 0.08);
}

.hp-bootstrap-card {
  border-radius: 0;
  border: 1px solid #dfe5ea;
  box-shadow: none;
}

.html-reference-card {
  border-radius: 0;
}

.soft-card {
  background: rgba(255, 255, 255, 0.88);
}

.hp-oj-banner-copy h4,
.section-title {
  margin: 0 0 12px;
  font-size: 1.22rem;
  font-weight: 700;
}

.hp-oj-banner-copy p {
  margin: 0;
  color: #475569;
}

.html-reference-grid {
  align-items: start;
}

.hp-member-card,
.hp-summary-card {
  padding: 0;
  overflow: visible;
  background: #ffffff;
  min-width: 0;
}

.hp-member-header,
.hp-summary-header,
.hp-add-member-trigger {
  display: flex;
  align-items: center;
  min-height: 58px;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  background: #ffffff;
  color: #212529;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 1.15;
  font-size: 1.125rem;
}

.hp-member-header {
  gap: 10px;
}

.hp-summary-header.active {
  color: #212529;
}

.hp-add-member-trigger {
  font-size: 1.125rem;
}

.hp-member-icon {
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 18px;
}

.hp-member-name {
  margin: 0;
  font-size: 1.1rem;
  line-height: 1.15;
  font-weight: 700;
  letter-spacing: 0.01em;
  min-width: 0;
  overflow-wrap: anywhere;
}

.hp-member-name small {
  display: block;
  margin-top: 4px;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.15;
}

.hp-member-body {
  position: relative;
  background: #ffffff;
}

.arrow-box {
  position: relative;
}

.hp-member-body-inner {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 26px 24px 24px;
}

.hp-member-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  color: #212529;
  min-width: 0;
}

.hp-member-status {
  margin: 0 0 6px;
  color: #212529 !important;
  font-weight: 700;
  font-size: 1.04rem;
  line-height: 1.2;
}

.hp-member-subcopy {
  color: #212529;
  font-size: 1.02rem;
  line-height: 1.25;
}

.onlinejoining-actions {
  display: flex;
  align-items: center;
  margin-top: 18px;
}

.hp-action-btn {
  min-width: 148px;
  color: #ffffff !important;
}

.progress-circle {
  flex: 0 0 92px;
  width: 92px;
  height: 92px;
}

.progress {
  position: relative;
  width: 92px;
  height: 92px;
  border-radius: 50%;
}

.progress-left,
.progress-right {
  position: absolute;
  top: 0;
  width: 46px;
  height: 92px;
  overflow: hidden;
}

.progress-left {
  left: 0;
}

.progress-right {
  right: 0;
}

.progress-bar {
  position: absolute;
  top: 0;
  width: 92px;
  height: 92px;
  border: 8px solid #d8dee4;
  border-radius: 50%;
  clip-path: inset(0 0 0 46px);
}

.progress-left .progress-bar {
  left: 0;
  clip-path: inset(0 46px 0 0);
}

.progress-right .progress-bar {
  left: -46px;
}

.progress-value {
  position: absolute;
  inset: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e7eb;
  border-radius: 50%;
  background: #ffffff;
}

.question-mark {
  font-size: 2rem;
  font-weight: 700;
  color: #212529;
  line-height: 1;
}

.hp-add-member {
  padding: 0;
}

.hp-add-member-trigger {
  width: 100%;
  justify-content: flex-start;
  gap: 12px;
  border: 0;
  cursor: default;
}

.hp-plus {
  position: relative;
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
}

.hp-plus::before,
.hp-plus::after {
  content: '';
  position: absolute;
  background: #212529;
}

.hp-plus::before {
  top: 6px;
  left: 0;
  width: 14px;
  height: 2px;
}

.hp-plus::after {
  top: 0;
  left: 6px;
  width: 2px;
  height: 14px;
}

.hp-summary-body {
  padding: 20px;
  color: #212529;
  font-size: 1rem;
  line-height: 1.3;
  min-width: 0;
  overflow-wrap: anywhere;
}

.hp-empty-state {
  text-align: center;
  color: #212529;
}

.hp-history-head,
.hp-history-item {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  gap: 18px;
}

.hp-history-head {
  margin-bottom: 14px;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.2;
}

.hp-history-item {
  margin-bottom: 18px;
}

.hp-history-course {
  font-size: 1.02rem;
  line-height: 1.25;
  min-width: 0;
  overflow-wrap: anywhere;
}

.hp-history-copy {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.hp-history-title {
  font-weight: 700;
  font-size: 1.02rem;
  line-height: 1.2;
}

.hp-history-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  font-size: 0.88rem;
  color: #475569;
  line-height: 1.2;
  min-width: 0;
  overflow-wrap: anywhere;
}

.hp-history-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

.hp-badge-row {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  gap: 18px;
  align-items: center;
}

.hp-badge-illustration {
  width: 78px;
  height: 110.1px;
  margin-left: 10px;
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hp-badge-empty-image {
  width: 78px;
  height: 110.1px;
  display: block;
  overflow: visible;
  flex: 0 0 78px;
}

.hp-badge-copy {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.hp-badge-title {
  font-weight: 700;
  color: #212529;
  font-size: 1.02rem;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.hp-badge-subtitle {
  color: #475569;
  font-size: 0.95rem;
  line-height: 1.2;
  overflow-wrap: anywhere;
}

.hp-login-column {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.field-label {
  margin-bottom: 8px;
  font-weight: 700;
  color: #585858;
  font-size: 1rem;
  line-height: 1.2;
}

.input-mock {
  border-radius: 0;
  border: 0;
  background: #edf1f5;
  padding: 0;
  margin-bottom: 14px;
  color: #64748b;
}

.html-input {
  border-radius: 0;
  border: 1px solid #edf1f5;
  background: #edf1f5;
  padding: 0;
  overflow: hidden;
}

.input-mock.with-icon {
  display: flex;
  align-items: center;
  gap: 0;
}

.input-icon {
  width: 52px;
  height: 52px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  background: transparent;
  color: #0f172a;
  flex: 0 0 52px;
}

.hp-input-group {
  margin-bottom: 16px;
}

.html-input .input-icon {
  width: 52px;
  height: 52px;
  border-radius: 0;
  background: transparent;
  font-size: 0;
}

.html-input span:last-child {
  font-size: 1.03rem;
  color: #585858;
  padding: 0;
  line-height: 52px;
}

.input-icon-svg {
  width: 18px;
  height: 18px;
  display: block;
}

.activation-copy,
.preview-card p {
  color: #475569;
  font-size: 1rem;
  line-height: 1.35;
}

.benefits-list {
  padding-left: 18px;
  color: #475569;
  font-size: 1rem;
  line-height: 1.4;
}

.link-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}

.inline-link {
  color: #f6ad55;
  text-decoration: underline;
  font-weight: 600;
}

.hp-login-card,
.hp-activate-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.hp-activate-card .benefits-list {
  margin-bottom: 24px;
}

.hp-activate-card .btn-homeportal {
  margin-top: auto;
}

.cta-primary,
.cta-secondary {
  border: none;
  border-radius: 0;
  padding: 12px 18px;
  font-weight: 700;
  cursor: default;
}

.btn-homeportal {
  min-width: 159px;
  box-shadow: none;
  color: #ffffff !important;
}

.compact {
  padding: 10px 14px;
}

.full-width {
  width: 100%;
}

.hp-nav-link:hover {
  color: #f6ad55;
  border-bottom-color: #f6ad55;
}

.preview-logo.nav {
  width: 188px;
  min-width: 188px;
  height: 32px;
  max-width: 188px;
  max-height: 32px;
  display: block;
  object-fit: contain;
  object-position: left center;
  flex: 0 0 188px;
}

.preview-logo.nav.fallback {
  filter: none;
}

.fallback-logo-inline {
  overflow: visible;
}

.preview-cookie-container {
  background-color: rgba(20, 20, 20, 0.8);
  color: #dedede;
  font-size: 0.92rem;
  line-height: 1.25;
  padding: 15px;
  margin-top: auto;
  text-align: center;
}

.preview-cookie-container h4 {
  margin: 0 0 8px;
  color: #ffffff;
  font-size: 1rem;
}

.preview-cookie-container p {
  margin: 0 0 12px;
  color: #dedede;
  overflow-wrap: anywhere;
}

.preview-cookie-container .cookie-buttons {
  display: inline-flex;
  align-items: center;
  gap: 16px;
}

.preview-cookie-container .hyperlink {
  color: #ffffff !important;
  text-decoration: underline;
}

.preview-cookie-container .btn-homeportal {
  min-width: auto;
  min-height: 45px;
  padding: 0 18px;
  line-height: 45px;
}

@media (max-width: 1100px) {
  .branding-preview-toolbar,
  .hp-oj-banner,
  .hp-navbar {
    grid-template-columns: 1fr;
    flex-direction: column;
    align-items: flex-start;
  }

  .hp-login-grid,
  .hp-overview-grid {
    grid-template-columns: 1fr;
  }

  .hp-sticky-panel {
    position: static;
  }
}

@media (max-width: 700px) {
  .mock-browser.full-window {
    min-height: calc(100vh - 240px);
  }

  .hp-login-page,
  .hp-dashboard-page {
    min-height: calc(100vh - 288px);
  }

  .hp-mobile-toggle {
    display: inline-flex;
  }

  .hp-nav-actions {
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .hp-member-body-inner,
  .hp-history-head,
  .hp-history-item,
  .hp-badge-row {
    grid-template-columns: 1fr;
    flex-direction: column;
    align-items: flex-start;
  }

  .hp-login-content,
  .hp-dashboard-content {
    padding-left: 18px;
    padding-right: 18px;
  }

  .preview-cookie-container .cookie-buttons {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
